import React from "react";
import SecretInput from "./SecretInput";
import { AUTH_TYPES, findAuthType } from "./resourceTypes";

/**
 * The Authentication tab — the auth type on the left, that type's fields on the
 * right.
 *
 * Parameters are stored under the keys the existing antd forms already use
 * (username/password, aud/iss/privateKey, domainName/clientID/clientSecret), so
 * a resource can be saved here and reopened there without losing its
 * credentials. See AUTH_TYPES in resourceTypes.js.
 *
 * Switching type keeps each type's parameters in place instead of clearing
 * them: picking Basic Auth, changing your mind, and coming back should not mean
 * typing the password again.
 */
export default function AuthPanel({ auth, onChange }) {
  const current = findAuthType(auth.type);
  const params = auth.params || {};

  const setParam = (key, value) => onChange({ ...auth, params: { ...params, [key]: value } });

  return (
    <div className="rsce-auth">
      <div className="rsce-auth-list">
        <div className="rsce-auth-list-head">Auth Type</div>
        {AUTH_TYPES.map((type) => (
          <button
            type="button"
            key={type.value}
            className={`rsce-auth-option ${type.value === current.value ? "is-active" : ""}`}
            onClick={() => onChange({ ...auth, type: type.value })}
          >
            {type.label}
          </button>
        ))}
      </div>

      <div className="rsce-auth-fields">
        {current.fields.length === 0 ? (
          <p className="rsce-auth-none">This endpoint is called without credentials.</p>
        ) : (
          current.fields.map((field) => (
            <div className="rsce-field" key={field.key}>
              <label className="rsce-field-label">{field.label}</label>
              {field.secret ? (
                <SecretInput
                  value={params[field.key]}
                  onChange={(value) => setParam(field.key, value)}
                  placeholder={field.placeholder}
                />
              ) : field.multiline ? (
                <textarea
                  className="rsce-textarea"
                  rows={5}
                  placeholder={field.placeholder}
                  value={params[field.key] || ""}
                  onChange={(e) => setParam(field.key, e.target.value)}
                />
              ) : (
                <input
                  className="rsce-input"
                  type="text"
                  placeholder={field.placeholder}
                  value={params[field.key] || ""}
                  onChange={(e) => setParam(field.key, e.target.value)}
                />
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
